import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { UserService } from '../services/user.service';
import { TokenStorageService } from '../services/token-storage.service';

@Injectable()
export class AuthGuard implements CanActivate {

  private roles: string[];

  constructor(private tokenService: TokenStorageService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.tokenService.isLoggedIn()){
      return true;
    } else {
      this.router.navigate(['/login']
      // ,{
      //   queryParams: {
      //     returnUrl: state.url
      //   }
      // }
      );
      return false;
    }
  }

}
